var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.855,
    height: 20,
    viewBox: "0 0 22.855 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_cubes",
    "data-name": "solid cubes",
    d: "M21.81,41.716,17.5,40.1V35.257a1.607,1.607,0,0,0-1.045-1.5L11.99,32.079a1.588,1.588,0,0,0-1.129,0L6.4,33.753a1.607,1.607,0,0,0-1.045,1.5V40.1L1.04,41.716A1.609,1.609,0,0,0,0,43.22v4.915a1.609,1.609,0,0,0,.888,1.437L5.352,51.8a1.6,1.6,0,0,0,1.437,0l4.638-2.321L16.065,51.8a1.6,1.6,0,0,0,1.437,0l4.464-2.232a1.609,1.609,0,0,0,.888-1.437V43.22A1.607,1.607,0,0,0,21.81,41.716Zm-5.83-1.58L12.186,41.56V38.516l3.794-1.652ZM6.874,35.195l4.553-1.705,4.553,1.705v.027l-4.553,1.848L6.874,35.221Zm3.75,12.994-3.794,1.9V46.555l3.794-1.732Zm0-5L6.071,45.037,1.518,43.189v-.027l4.553-1.705,4.553,1.705Zm10.713,5-3.794,1.9V46.555l3.794-1.732Zm0-5-4.553,1.848-4.553-1.848v-.027l4.553-1.705,4.553,1.705Z",
    transform: "translate(0 -31.975)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockIcon);
export default __webpack_public_path__ + "static/media/stock-icon.30657cf95f4e105a0a6718527feb649e.svg";
export { ForwardRef as ReactComponent };